import Vue from 'vue';
import * as types from './mutation-types';
import { compileAsyncMutations } from '@/utils/async';


// Will be default export
const mutations = {

  /**
   * Add the GW templates of multiple teams in state.templatesPerTeam
   * This is complementary to GET_GW_TEMPLATES.stateKey as it may contain
   * templates of other teams as well
   */
  [types.SET_TEAM_GW_TEMPLATES](state, params) {
    const data = params.data instanceof Array ? params.data : [];
    const templatesPerTeam = data.reduce((teams, gw) => {
      const gwPerTeam = [...(teams[`${gw.team}`] || []), gw];
      return { ...teams, [`${gw.team}`]: gwPerTeam };
    }, {});
    Object.freeze(templatesPerTeam);
    Object.keys(templatesPerTeam).forEach((teamId) => {
      Vue.set(state.templatesPerTeam, `${teamId}`, templatesPerTeam[`${teamId}`] || []);
    });
  },

  /**
   * Add the GW checklists of multiple teams in state.checklistsPerTeam
   * This is complementary to GET_GW_CHECKLISTS.stateKey as it may contain
   * checklists of other teams as well
   */
  [types.SET_TEAM_GW_CHECKLISTS](state, params) {
    const data = params.data instanceof Array ? params.data : [];
    const checklistsPerTeam = data.reduce((teams, cl) => {
      const clPerTeam = [...(teams[`${cl.team}`] || []), cl];
      return { ...teams, [`${cl.team}`]: clPerTeam };
    }, {});
    Object.freeze(checklistsPerTeam);
    Object.keys(checklistsPerTeam).forEach((teamId) => {
      Vue.set(state.checklistsPerTeam, `${teamId}`, checklistsPerTeam[`${teamId}`] || []);
    });
  },

  /** Save a single occurrence of a GW to state */
  [types.SET_GW](state, payload) {
    if (payload && payload.data instanceof Object && payload.data.id) {
      Vue.set(state.gwPerId, `${payload.data.id}`, payload.data);
    }
  },

};

// For each async mutations, dynamically add three mutations
// See @/utils/async for more details
compileAsyncMutations(mutations, types);

export default mutations;
